document.addEventListener(
  "submit",
  function (e) {
    const form = e.target;
    if (!form || form.tagName !== "FORM") return;
    if (!form.classList.contains("newsletter-form--interests-selectable")) return;
    const hidden = form.querySelector('input[name="contact[tags]"]');
    if (!hidden) return;
    const tags = (hidden.value || "")
      .split(",")
      .map(function (tag) {
        return tag.trim();
      })
      .filter(Boolean);
    form.querySelectorAll(".newsletter-interest-cb:checked").forEach(function (cb) {
      const t = cb.getAttribute("data-tag");
      if (t) tags.push(t);
    });
    hidden.value = tags.join(",");
  },
  true,
);
